define('MultipleAddToCart.Backbone.History', [
    'GlobalViews.Confirmation.View',
    'SC.Configuration',
    'Backbone',
    'Utils',
    'jQuery',
    'underscore'
],
function AwaLabsMultipleAddToCartPLP(
    GlobalViewsConfirmationView,
    Configuration,
    Backbone,
    Utils,
    jQuery,
    _
) {
    'use strict';

    var originalLoadUrl = window.Backbone.history.loadUrl;
    window.isNavigationBlocked = false;

    return {
        mountToApp: function mountToApp(application) {
            var layout = application.getComponent('Layout');
            var categoryPathname;

            window.Backbone.history.loadUrl = function wrapLoadUrl(url) {
                var modal;
                var body;
                var urlParameters = Utils.parseUrlOptions(url);
                var auxPathname;

                if (url !== categoryPathname) {
                    auxPathname = url; // When modal opens up we replace path so we save the new one to redirect in case user wants to leave.
                }

                if (urlParameters.showinmodal === 'T') {
                    return originalLoadUrl.apply(this, arguments); // Prevents modal popup if url comes with showinmodal. example: quick view.
                }

                if (jQuery('.multiple-add-to-cart-plp-actions-wrapper').length && window.isNavigationBlocked) {
                    body = Configuration.get('multiAddToCart.preventLeaveModalBody') ||
                        Utils.translate('You have items in the queue to be added to the cart, click Add to Cart to add them or click Ok to loose the items.');

                    modal = new GlobalViewsConfirmationView({
                        callBack: function callBack() {
                            window.isNavigationBlocked = false;
                            Backbone.history.navigate(auxPathname, { trigger: true, replace: true });
                        },
                        title: Configuration.get('multiAddToCart.preventLeaveModalTitle') || Utils.translate('You will lose your items'),
                        body: body,
                        autohide: true,
                        confirmLabel: Configuration.get('multiAddToCart.preventLeaveModalConfirmButton') || Utils.translate('Ok')
                    });

                    Backbone.history.navigate(categoryPathname, { trigger: false, replace: true });

                    layout.showContent(modal, { showInModal: true, options: { className: 'multiple-add-to-cart-prevent-modal' } });

                    return false;
                }

                return originalLoadUrl.apply(this, arguments);
            };

            application.getLayout().on('afterAppendView', function (view) {
                if (view.$('.multiple-add-to-cart-plp-actions-wrapper').length) {
                    categoryPathname = Backbone.history.fragment;
                }
            });
        }
    };
});
